/* eslint-disable prefer-rest-params */
import { AxiosResponse } from 'axios';
import { API_ROUTES } from '../../../constants/app';
import { Command } from '../../../types/commands';
import axios, { handleUnauthorized } from '../../axios';
import { WIDGET_TYPE } from '../../../types';
import { getNewWidgetByType } from '../../../components/widgets/helpers';

export async function addNewSpacerWidgetToSection(
  guideId: string,
  chapterId: string,
  pageId: string,
  sectionId: string,
  widgetId: string,
  widgetType: WIDGET_TYPE.SPACER,
  columnIndex: number,
  guideVersion: number,
): Promise<AxiosResponse> {
  const emptyWidgetState = getNewWidgetByType(widgetType);

  return (await axios())
    .post(API_ROUTES.GUIDES_WRITE, {
      command: Command.ADD_NEW_SPACING_WIDGET_TO_SECTION,
      aggregateId: guideId,
      aggregateVersion: guideVersion,
      payload: {
        chapterId,
        pageId,
        sectionId,
        widgetId,
        columnIndex,
        widgetSpacingPayload: {
          ...emptyWidgetState,
        },
      },
    })
    .catch(error =>
      handleUnauthorized(error, addNewSpacerWidgetToSection, ...arguments),
    );
}

export async function editStyleInSpacingWidget(
  guideId: string,
  chapterId: string,
  pageId: string,
  sectionId: string,
  widgetId: string,
  columnIndex: number,
  stylesheet: string,
  guideVersion: number,
): Promise<AxiosResponse> {
  return (await axios())
    .post(API_ROUTES.GUIDES_WRITE, {
      command: Command.EDIT_STYLE_IN_SPACING_WIDGET,
      aggregateId: guideId,
      aggregateVersion: guideVersion,
      payload: {
        chapterId,
        pageId,
        sectionId,
        widgetId,
        columnIndex,
        style: {
          stylesheet,
          language: 'css',
          version: 3,
        },
      },
    })
    .catch(error =>
      handleUnauthorized(error, editStyleInSpacingWidget, ...arguments),
    );
}
export async function editHeightInSpacingWidget(
  guideId: string,
  chapterId: string,
  pageId: string,
  sectionId: string,
  columnIndex: number,
  widgetId: string,
  widgetHeight: number,
  guideVersion: number,
): Promise<AxiosResponse> {
  return (await axios())
    .post(API_ROUTES.GUIDES_WRITE, {
      command: Command.EDIT_HEIGHT_IN_SPACING_WIDGET,
      aggregateId: guideId,
      aggregateVersion: guideVersion,
      payload: {
        chapterId,
        pageId,
        sectionId,
        columnIndex,
        widgetId,
        widgetHeight,
      },
    })
    .catch(error =>
      handleUnauthorized(error, editHeightInSpacingWidget, ...arguments),
    );
}

export async function editDividerInSpacingWidget(
  guideId: string,
  chapterId: string,
  pageId: string,
  sectionId: string,
  widgetId: string,
  columnIndex: number,
  widgetDivider: string,
  guideVersion: number,
): Promise<AxiosResponse> {
  return (await axios())
    .post(API_ROUTES.GUIDES_WRITE, {
      command: Command.EDIT_DIVIDER_IN_SPACING_WIDGET,
      aggregateId: guideId,
      aggregateVersion: guideVersion,
      payload: {
        chapterId,
        pageId,
        sectionId,
        widgetId,
        columnIndex,
        widgetDivider,
      },
    })
    .catch(error =>
      handleUnauthorized(error, editDividerInSpacingWidget, ...arguments),
    );
}
